import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "evrideo-content-control-studio-dropdown",
  templateUrl: "./content-control-studio-dropdown.component.html",
  styleUrl: "./content-control-studio-dropdown.component.scss",
})
export class ContentControlStudioDropdownComponent {
  @Input("options") options: Array<string> = [];
  @Input("is-multi") isMulti: boolean = false;
  @Input("icon-is-button") isButtonIcon = false;
  @Input("selectedOption") selectedOption = "";
  @Input("selected-options") selectedOptions: string[] = [];
  @Output("selectedChanged") selectedOptionChanged: EventEmitter<string> =
    new EventEmitter<string>();
  @Output("multi-selection-changed") multiSelectedChanged: EventEmitter<
    Array<string>
  > = new EventEmitter<Array<string>>();
  public isMenuOpen = false;

  onOpenMenu;
  onSelectedOptionChanged(option: string) {
    if (this.isMulti) {
      if (this.selectedOptions.includes(option)) {
        this.selectedOptions.splice(
          this.selectedOptions.findIndex((x) => x == option),
          1,
        );
      } else {
        this.selectedOptions.push(option);
      }
      this.multiSelectedChanged.emit(this.selectedOptions);
    } else {
      this.isMenuOpen = false;
      this.selectedOptionChanged.emit(option);
    }
  }
  onSelectClicked(event: any) {
    if (this.options.length > 0) {
      this.isMenuOpen = !this.isMenuOpen;
    }
  }
}
